module.exports = __webpack_public_path__ + "img/input-reset.6597cd1d.svg";